import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    key: String
  }

  static targets = ["address", "city", "region", "country", "postalCode"]

  connect() {
    this.debounceTimeout = null
    this.documentClickListener = null
  }

  removeExistingPreview() {
    const existingPreview = document.querySelector('.address-preview-window')
    if (existingPreview) {
      existingPreview.remove()
    }
    if (this.documentClickListener) {
      document.removeEventListener('click', this.documentClickListener)
      this.documentClickListener = null
    }
  }

  selectAddressFromId(id) {
    fetch('https://api.postgrid.com/v1/intl_addver/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.keyValue
      },
      body: JSON.stringify({ id })
    })
    .then(response => response.json())
    .then(data => {
      if (data.data) {
        const address = data.data
        this.addressTarget.value = address.line1 || ''
        this.cityTarget.value = address.city || ''
        this.regionTarget.value = address.provinceCode || ''
        this.postalCodeTarget.value = address.postalOrZip || ''
        this.countryTarget.value = address.countryCode || ''
      }
    })
    .catch(error => {
      console.error('Error fetching address details:', error)
    })
  }

  query() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.debounceTimeout = setTimeout(() => {
      const query = this.addressTarget.value
      if (!query || query.length < 3) return

      fetch('https://api.postgrid.com/v1/intl_addver/completions?' + new URLSearchParams({
        partialStreet: query,
        limit: 6,
        language: 'EN'
      }).toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': this.keyValue
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.data?.length > 0) {
          this.showAddressPreview(data.data)
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
    }, 300)
  }

  showAddressPreview(suggestions) {
    this.removeExistingPreview()

    const previewWindow = document.createElement('div')
    previewWindow.classList.add('address-preview-window')
    
    Object.assign(previewWindow.style, {
      position: 'absolute',
      zIndex: '9999',
      background: 'white',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      maxHeight: '200px',
      overflowY: 'auto',
      width: `${this.addressTarget.offsetWidth}px`
    })

    const inputRect = this.addressTarget.getBoundingClientRect()
    previewWindow.style.top = `${inputRect.bottom + window.scrollY}px`
    previewWindow.style.left = `${inputRect.left + window.scrollX}px`

    suggestions.forEach(suggestion => {
      if (suggestion.type !== 'Address') return
      
      const item = document.createElement('div')
      item.classList.add('address-preview-item')
      Object.assign(item.style, {
        padding: '8px 12px',
        cursor: 'pointer'
      })
      item.textContent = suggestion.text
      
      const description = document.createElement('div')
      description.style.fontSize = '0.8em'
      description.style.color = '#666'
      description.textContent = suggestion.description
      item.appendChild(description)
      
      item.addEventListener('mouseover', () => {
        item.style.backgroundColor = '#f5f5f5'
      })
      
      item.addEventListener('mouseout', () => {
        item.style.backgroundColor = 'white'
      })

      item.addEventListener('click', () => {
        this.addressTarget.value = suggestion.text
        this.selectAddressFromId(suggestion.id)
        this.removeExistingPreview()
      })

      previewWindow.appendChild(item)
    })

    document.body.appendChild(previewWindow)

    this.documentClickListener = (e) => {
      if (!previewWindow.contains(e.target) && e.target !== this.addressTarget) {
        this.removeExistingPreview()
      }
    }
    document.addEventListener('click', this.documentClickListener)
  }
}
